import { FaStethoscope } from "react-icons/fa";

export const ServiciosDoctor = ({servicios}) => {
  return (
    
    <div className="container-servicios">
        <h4 className="ms-3"><b>Servicios</b></h4>
        <div className="container-cards">
            {
                servicios.map( serv => {
                    if(!servicios) return;
                    const { id, descripcion, nombre } = serv;
                    return (
                        <div className="card card-servicio" key={ id }>
                            <div className="icons-style">
                                <FaStethoscope size={25}/>
                            </div>
                            <div className="mt-4">
                                <h6><b>{ nombre }</b></h6>
                                <p>{ descripcion }</p>
                            </div>
                        </div>
                    )
                })
            }
        </div>

    </div>

  )
}
